export default {
  state: {
    set_auth_manage: [],
  },
  actions: {// 在action中可以进行异步操作，外部用dispatch()调用
    set_auth_manage ({commit, state}, param) {
      commit('setAddOrEditPaymentDialog', param)
    },
  },
  getters: {// 获取state里面的数据
    set_auth_manage (state) {
      return state.set_auth_manage
    },
  },
  mutations: {// 不要在mutations里面进行异步操作，外部用commit()调用
    setAddOrEditPaymentDialog (state, action) {
      state.set_auth_manage = action
    },
  }
}



// WEBPACK FOOTER //
// ./src/store/authManage/index.js